import { render, staticRenderFns } from "./Product_stock.vue?vue&type=template&id=3d3e574e&scoped=true&"
import script from "./Product_stock.vue?vue&type=script&lang=js&"
export * from "./Product_stock.vue?vue&type=script&lang=js&"
import style0 from "./Product_stock.vue?vue&type=style&index=0&id=3d3e574e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e574e",
  null
  
)

export default component.exports